// ISDP CUSTOM: Entire file — Landscape plugin registration (mounted at /landscape in App.tsx)
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const landscapePlugin = createPlugin({
  id: 'landscape',
  routes: {
    root: rootRouteRef,
  },
});

export const LandscapePage = landscapePlugin.provide(
  createRoutableExtension({
    name: 'LandscapePage',
    component: () =>
      import('./components/LandscapePage').then(m => m.LandscapePage),
    mountPoint: rootRouteRef,
  }),
);
